import { useContext } from 'react';

import { ModalsContext } from '~/contexts/ModalsContext';

export default function useModals() {
  return useContext(ModalsContext);
}
